﻿import {UIText} from "../Tools/Base/UIText";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {Utils} from "../../Utils/Utils";
// import { MissionReward } from "../Tools/Mission/MissionReward";
import {UISprite} from "../Tools/Base/UISprite";

class MissionReward extends UISprite {
    constructor(reward) {
        super();
        this.reward = reward;

        this.label = null;
        this.icon = null;
        this.UpdateUI();

        this.text = this.addChild(new UIText(this.label));
        this.image = this.addChild(new UISprite(this.icon));
    }

    UpdateUI() {
        switch (this.reward.type) {
            case RewardType.MaxCreature:
                this.label = "+1";
                this.icon = "box";
                break;

            case RewardType.MoneySoftBySoftSpeed:
                this.label = NUtils.FormatMoney(this.reward.value * GameManager.gameController.MoneySoftSpeed);
                this.icon = "bank/pack-gold-sack";
                break;

            case RewardType.MoneyHard:
                this.label = NUtils.FormatMoney(this.reward.value);
                this.icon = "bank/pack-gems-handful";
                break;

            default:
                this.label = "";
                this.icon = "";
                break;
        }
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);

        let newRect = rect.clone();
        newRect.width = rect.width;
        newRect.height = rect.height * 0.8;
        newRect.x = (rect.width - newRect.width) * 0.5;
        newRect.y = (rect.height - newRect.height) * 0;
        this.image.fitRect(newRect);

        newRect = rect.clone();
        newRect.width = rect.width;
        newRect.height = rect.height * 0.2;
        newRect.x = (rect.width - newRect.width) * 0.5;
        newRect.y = (rect.height - newRect.height) * 1;
        this.text.fitLayout(newRect);
    }
}

export class UIMissionRewards extends UICommonPopup {
    Awake() {
        super.Awake();
        this.back.alpha = 0;
        this.collectBtn = this.content.addChild(new UINineSliceButton("btn-green", Core.Localizator.Get("collect")));
        this.progressTitle = this.content.addChild(new UIText(Core.Localizator.Get("mission_rewards_title")));
        this.progressField = this.content.addChild(new UIText("", { fill: "gray" }));
        this.rewards = [];
        this.items = [];
        this.currentRewardIndex = 0;

        this.allItemsContainer = this.content.addChild(new UISprite(""));
        this.allItemsContainer.visible = false;
    }

    Init() {
        super.Init();
        this.collectBtn.on("pointertap", () => {
            if (this.currentRewardIndex > this.rewards.length) {
                this.Hide();
                Core.UI.missionEmpty.Show();
            } else {
                this.updateCurrentReward();
            }
        });
    }

    Show(missionId = null, rewards = null) {
        this.rewards = rewards;
        this.currentRewardIndex = 0;

        this.allItemsContainer.removeChildren();
        this.allItemsContainer.visible = false;
        
        while (this.items.length) this.content.removeChild(this.items.shift());
        for (let r of rewards) {
            r.Take("mission_reward");
            let item = this.content.addChild(new MissionReward(r));
            this.items.push(item);

            item = this.allItemsContainer.addChild(new MissionReward(r));
        }

        Core.Player.Missions.FinishMission();

        this.updateCurrentReward();

        let missionData = Core.GameData.Missions.GetMission(missionId);
        Core.Analytics.SendMissionEvent(missionId, missionData.durationSeconds, "");

        super.Show();
    }

    updateCurrentReward() {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].SetActive(i === this.currentRewardIndex);
        }
        if (this.currentRewardIndex < this.rewards.length) {
            this.progressField.SetActive(true);
            this.progressField.text = Utils.Format("{0}/{1}", this.currentRewardIndex + 1, this.rewards.length);
        } else {
            this.allItemsContainer.visible = true;
            this.progressField.SetActive(false);
        }
        this.currentRewardIndex++;
    }

    fitLayout(viewport = Core.app.viewport) {
        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.6;
        rect.height = contentRect.height * 0.12;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.92;
        this.collectBtn.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.9;
        rect.height = contentRect.height * 0.06;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.1;
        this.progressTitle.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.3;
        rect.height = contentRect.height * 0.06;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.18;
        this.progressField.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.6;
        rect.height = contentRect.width * 0.6;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.5;

        for (let item of this.items) {
            item.fitLayout(rect);
        }

        let y = this.items.length === 2 ? 0.5 : 0.3;

        let map = [
            { x: 0, y: y },
            { x: 1, y: y },
            { x: 0.5, y: 0.7 },
        ];

        this.allItemsContainer.children.forEach((child, i) => {
            let rect = contentRect.clone();
            rect.width = contentRect.width * 0.55;
            rect.height = contentRect.width * 0.55;
            rect.x = (contentRect.width - rect.width) * map[i].x;
            rect.y = (contentRect.height - rect.height) * map[i].y;

            child.fitLayout(rect);
        });
    }
}
